import { ResourceOptions } from 'react-admin';
import { FaGift } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.redpacketDesignatedRedPackets;
export const icon = FaGift;
export const options: ResourceOptions = {
  label: 'module.redpacket.designatedRedPackets',
};
